<script setup lang="ts">
defineProps<{
    invalid?: boolean;
    message?: string | null;
}>();
</script>

<template>
    <div
        class="grid overflow-hidden [transition:grid-template-rows_.2s_ease,opacity_.2s_ease,margin-top_.2s_ease] motion-reduce:transition-none"
        :class="invalid ? 'mt-[4px] grid-rows-[1fr] opacity-100' : 'mt-0 grid-rows-[0fr] opacity-0'"
        :aria-hidden="invalid ? undefined : 'true'"
        :inert="invalid ? undefined : true"
        :data-open="invalid ? 'true' : 'false'"
        data-form-error
    >
        <small
            class="block min-h-0 overflow-hidden text-ui-helper/[1.45] font-[500] text-danger dark:text-danger-dark"
            :role="invalid ? 'alert' : undefined"
            data-form-error-message
        >
            {{ message }}
        </small>
    </div>
</template>
